import styled from 'styled-components';
import { ContentWidthWrapper } from '@pass-frontend/common/components/content-width-wrapper/ui';
import { useIntl } from '@pass-frontend/common/i18n';
import { FitnessYourWayProps } from '@pass-frontend/features/standalone/data-access';
import { MEDIA_QUERY } from '@pass-frontend/utility/style-helpers';

const StyledSectionWrapper = styled.section`
  padding: 24px 0;

  .heading {
    margin-bottom: 16px;
  }

  .description {
    margin-bottom: 24px;
  }

  .cta {
    width: 100%;
  }

  ${MEDIA_QUERY.desktop} {
    padding: 56px 0;

    .heading {
      margin-bottom: 8px;
    }

    .description {
      margin-bottom: 32px;
    }

    .cta {
      width: auto;
    }
  }
`;

export const FitnessYourWay = (props: FitnessYourWayProps) => {
  const { headerKey, descriptionKey, buttonTextKey, handleClick } = props;
  const { t } = useIntl();

  return (
    <StyledSectionWrapper className="has-bg-sky-blue has-text-centered">
      <ContentWidthWrapper>
        <h2 className="is-h2 has-text-blue-1 heading">{t(headerKey)}</h2>
        <p className="is-body-1-regular has-text-blue-1 description">
          {t(descriptionKey)}
        </p>
        {buttonTextKey && (
          <button
            type="button"
            className="btn btn-primary cta"
            onClick={handleClick}
            data-ui-element-name="fitness-your-way-get-started-btn"
          >
            {t(buttonTextKey)}
          </button>
        )}
      </ContentWidthWrapper>
    </StyledSectionWrapper>
  );
};
